import {
  takeLatest, call, cancel, SagaReturnType,
} from 'redux-saga/effects';
import { select } from 'app/store/utils/saga/effects';
import { IPagePromo, IPageEnd } from 'app/store/nodes/card/interfaces';

import * as request from 'app/lib/provider/request';

import * as promoActions from '../actions';

export const config = {
  action: [promoActions.sendViewed.type, promoActions.sendTapped.type],
  method: takeLatest,
};

export function* func(action: promoActions.ISendViewedPayload | promoActions.ISendTappedPayload) {
  const { eventViewed, eventTapped } = yield* select((state) => state.promo);
  const isActionViewed = action.type === promoActions.sendViewed.type;
  const isActionTapped = action.type === promoActions.sendTapped.type;

  if (isActionViewed && eventViewed.updatedAt !== action.payload.callTime) {
    yield cancel(); return;
  }

  if (isActionTapped && eventTapped.updatedAt !== action.payload.callTime) {
    yield cancel(); return;
  }

  const cardUuid = yield* select((state) => state.card?.common.uuid);
  const pages = yield* select((state) => state.card?.pages);
  const b2bPromoId = (pages.find((page) => page.type === 'PagePromo') as IPagePromo)?.items?.promo?.id;
  const b2cPromoId = (pages.find((page) => page.type === 'PageEnd') as IPageEnd)?.items?.promo?.id;
  const promoId: number = b2bPromoId || b2cPromoId || 0;

  if (!promoId) {
    yield cancel(); return;
  }

  let promoAction: string = '';
  if (isActionViewed) {
    promoAction = 'viewed';
  }
  if (isActionTapped) {
    promoAction = 'tapped';
  }
  if (!promoAction) {
    yield cancel(); return;
  }

  const response: SagaReturnType<typeof request.promo> = yield call(() => request.promo(cardUuid, promoId, promoAction));
  if (!response) {
    yield cancel();
  }
}
